import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import ReactSelect from "react-select";
import InfoTooltip from './InfoToolTip';
import FormError from "./FormError";

const SelectMultiple = ({ value, onChange, loading, label, alert, placeholder, name, required, className, icon, array, image, isMulti, nameArray, tooltip, disabled }) => {
    const [options, setOptions] = useState([]);
    const [defaultValue, setDefaultValue] = useState(isMulti ? [] : null);

    const customStyles = {
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
        menu: (provided) => ({
            ...provided,
            maxHeight: '150px',
            overflowY: 'auto',
            margin: 0,
        }),
        menuList: (provided) => ({
            ...provided,
            padding: 0,
            maxHeight: '150px',
            overflowY: 'auto',
        }),
    };

    useEffect(() => {
        // Limpiar selecciones si el valor es vacío
        if (value === '' || (Array.isArray(value) && value.length === 0)) {
            setDefaultValue(isMulti ? [] : null);
            return;
        }

        if (isMulti) {
            if (Array.isArray(value) && value.length > 0) {
                const arraySet = value.map((id) => {
                    const foundItem = array.find((item) => item.id == id);
                    return foundItem ? {
                        value: foundItem.id,
                        label: nameArray ? foundItem[nameArray] : foundItem.name,
                        ...(image && { image: foundItem[image] })
                    } : null;
                }).filter(Boolean);
                setDefaultValue(arraySet);
            }
        } else {
            const foundItem = array.find((item) => item.id == value);
            if (foundItem) {
                setDefaultValue({
                    value: foundItem.id,
                    label: nameArray ? foundItem[nameArray] : foundItem.name,
                    ...(image && { image: foundItem[image] })
                });
            } else {
                setDefaultValue(null);
            }
        }
    }, [value, array, nameArray, image, isMulti]);

    useEffect(() => {
        if (Array.isArray(array) && array.length > 0) {
            const arraySet = array.map((item) => ({
                value: item.id,
                label: nameArray ? item[nameArray] : item.name,
                ...(image && { image: item[image] })
            }));
            setOptions(arraySet);
        } else {
            setOptions([]);
        }
    }, [array, nameArray, image]);

    const formatOptionLabel = ({ label, image }) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {image && <img className={`w-8 h-8 mr-2 ${image === '' && 'invisible'}`} src={`data:image/png;base64,${image}`} alt="" />}
            {label}
        </div>
    );

    const handleChange = (selectedOption) => {
        if (isMulti) {
            setDefaultValue(selectedOption || []);
            onChange(selectedOption ? selectedOption.map((item) => item.value) : []);
        } else {
            setDefaultValue(selectedOption || null);
            onChange(selectedOption ? selectedOption.value : null);
        }
    };

    return (
        <>
            {label && <label className="mb-2.5 text-black flex justify-between text-xs dark:text-white font-medium">
                <span>{label} {required && <span className="text-red-500">*</span>}</span>
            </label>}
            
            {loading ? (
                <Skeleton className="w-full rounded py-3 px-5 text-2xl" />
            ) : (
                <div className="relative">
                    <ReactSelect
                        name={name}
                        onChange={handleChange}
                        styles={customStyles}
                        hideSelectedOptions={true}
                        formatOptionLabel={image ? formatOptionLabel : null}
                        value={defaultValue}
                        isMulti={isMulti}
                        options={options}
                        isClearable={true}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        placeholder={placeholder || "Seleccione una opción"}
                        noOptionsMessage={() => 'No hay más opciones'}
                        className={`${className || ""} ${icon && "pl-12"}`}
                        isDisabled={disabled || false}
                    />
                    {icon && <span className="absolute left-4 top-1/2 transform -translate-y-1/2">{icon}</span>}
                </div>
            )}
            
            {alert && <FormError errors={alert} name={name} />}
        </>
    );
};

SelectMultiple.defaultProps = {
    array: [],
    value: null,
    nameArray: 'name',
    image: null,
    isMulti: false,
};

export default SelectMultiple;